import { useQuery } from 'react-query';
import request from '../../../../../helpers/request';

const createKey = () => ['massActionsRequestExecutors'];

const fetch = () =>
  request.get(
    `/Request/executers`,
    {},
    `Произошла ошибка при загрузке исполнителей`,
    'Error'
  );

const useFetch = (options) => useQuery(createKey(), fetch, options);

const queryData = { createKey, useFetch };

export default queryData;
